'use client';

import { useEffect } from 'react';
import { useRouter } from 'next/navigation';
import { useAuth } from '@/hooks/useAuth';
import HomeClient from '@/components/HomeClient';

export default function HomePage() {
  const { user, profile, loading } = useAuth();
  const router = useRouter();

  useEffect(() => {
    // Se non sta caricando e non c'è utente → redirect al login
    if (!loading && !user) {
      router.push('/login');
    }
  }, [loading, user, router]);

  // Mostra loading spinner mentre controlla l'auth
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 to-indigo-100">
        <div className="text-center">
          <div className="w-12 h-12 border-4 border-blue-600 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-gray-600">Caricamento...</p>
        </div>
      </div>
    );
  }

  // Se non c'è utente, non mostrare niente (sta facendo redirect)
  if (!user) {
    return null;
  }

  // Mostra la dashboard con i dati reali dell'utente
  return <HomeClient userName={profile?.first_name || 'Studente'} userId={user.id} />;
}